import script from "./account.vue?vue&type=script&setup=true&lang=ts"
export * from "./account.vue?vue&type=script&setup=true&lang=ts"

import "./account.vue?vue&type=style&index=0&id=405493ce&lang=scss"
import "./account.vue?vue&type=style&index=1&id=405493ce&scoped=true&lang=scss"

import exportComponent from "D:\\全部项目\\funeral-and-interment\\publicnumber\\node_modules\\.store\\vue-loader@16.8.3\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-405493ce"]])

export default __exports__